import { Router } from '@angular/router';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { MainTableModuleNamesEnum } from 'src/app/shared/enums/main-table-module-names.enum';

@Component({
  selector: 'app-main-table-expandable-row',
  templateUrl: './main-table-expandable-row.component.html',
  styleUrls: ['./main-table-expandable-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MainTableExpandableRowComponent implements OnChanges, OnDestroy {
  @Input() displayedColumns: string[];
  @Input() detailsDisplayedColumns: string[];
  @Input() moduleName: string;
  @Input() parentRow: any;
  @Input() urlForRow: string;
  @Input() specificTemplateName: string;
  @Input() tableData: any;
  @Input() disabledColumnHeaders: string[] = [];
  @Input() columnTitlesMap: Record<string, string> = {};
  @Input() clickableColumns: string[] = [];

  @Output() readonly columnHandler = new EventEmitter<{
    event: MouseEvent;
    column: string;
    row: any;
  }>();

  dataSource: MatTableDataSource<any>;
  disabled: any;
  hideColumns = true;

  private subscriptions = new Subscription();

  constructor(
    private router: Router,
    private store: Store
  ) {}

  ngOnChanges(): void {
    if (this.moduleName === MainTableModuleNamesEnum.RunTime) {
      this.dataSource = new MatTableDataSource(this.tableData ? this.tableData : []);
    } else {
      this.dataSource = new MatTableDataSource([this.parentRow]);
      this.displayedColumns = this.detailsDisplayedColumns;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleColumnClick(event: MouseEvent, column: string, row: any) {
    if (
      this.clickableColumns.includes(column) &&
      this.moduleName === MainTableModuleNamesEnum.RunTime
    ) {
      event.stopPropagation();
      // if (column === 'dropdownForRunTimeChildren__hidden') {
      // const filterForRunTimeChildren = new MainTableFilterModel(
      //   MainTableFilterModulesEnum.RunTime
      // );
      // filterForRunTimeChildren.pageIndex = 0;
      // // eslint-disable-next-line no-magic-numbers
      // filterForRunTimeChildren.pageSize = 10000;
      // this.store.dispatch(new LoadRunTimeChildrenForTable(row.id, filterForRunTimeChildren));

      // this.expandedElement = this.expandedElement === row ? null : row;
      // } else {
      // TODO add above when multi level deep children are in place
      this.columnHandler.emit({ event, column, row });
    }
  }

  routeTo(row: any): void {
    if (this.moduleName === MainTableModuleNamesEnum.RunTime) {
      this.router.navigate([`${this.urlForRow}/${row.id}`]);
    }
  }
}
